export class LayoutFilterSettingsConstants {
    public static readonly allUsers = 'All_Users';
}